"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEditPunch = void 0;
const react_1 = require("react");
const react_query_1 = require("react-query");
const fetchClient_1 = require("../../client/fetchClient");
const paths_1 = require("../../paths");
const DateManagement_1 = require("../../utils/DateManagement");
const eventEmitter_1 = require("../../utils/EventEmitter/eventEmitter");
const taaEvents_1 = require("../../utils/EventEmitter/taaEvents");
const MealBreakLockoutValidation_1 = require("../../utils/MealBreakLockoutValidation");
const taaConfigs_1 = require("../../contexts/taaConfigs");
const logger_1 = require("../../logger");
function useEditPunch(props) {
    const { clientName, currentStage } = (0, taaConfigs_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB
    };
    const { isLoading: loading, error, mutate } = (0, react_query_1.useMutation)((0, fetchClient_1.submitData)(currentStage));
    const [data, setData] = (0, react_1.useState)('');
    const usageLocation = props.usageLocation;
    const editPunch = (oldPunchDateTime, newPunchTime, newPunchDate, useMilitaryTime, isHistorical, punchWithTimespans) => {
        const newTimestamp = (0, DateManagement_1.parsePunchTime)(newPunchTime, newPunchDate, useMilitaryTime).toISO();
        const mealBreakValidationDateTimes = (0, MealBreakLockoutValidation_1.getMealBreakValidationDateTimes)(newTimestamp, oldPunchDateTime.timestamp, punchWithTimespans);
        mutate({
            path: (0, paths_1.EDIT_PUNCH_API)(props.employeeId || ''),
            method: 'POST',
            body: {
                employeeId: props.employeeId || '',
                siteId: props.siteId || '',
                oldPunchDateTime: {
                    timestamp: oldPunchDateTime.timestamp,
                    timezone: oldPunchDateTime.timezone || props.timeZone
                },
                newPunchDateTime: {
                    timestamp: newTimestamp,
                    timezone: oldPunchDateTime.timezone || props.timeZone
                },
                isHistorical,
                mealBreakValidationDateTimes
            },
            metaData: {
                apiName: 'editPunch',
                clientName
            },
            usageLocation
        }, {
            onSuccess: ({ requestId }) => {
                eventEmitter_1.Emitter.emit(taaEvents_1.taaEvents.SUBMIT_PUNCH, { responseCode: 200 });
                logger_1.logger.emitCountMetric({
                    metricName: isHistorical
                        ? logger_1.METRICS.PUNCH_EDIT_REQUEST_HISTORICAL_SUCCESS.COUNT
                        : logger_1.METRICS.PUNCH_EDIT_REQUEST_NON_HISTORICAL_SUCCESS.COUNT,
                    dimensions
                });
                setData(requestId);
            },
            onError: (error) => {
                eventEmitter_1.Emitter.emit(taaEvents_1.taaEvents.SUBMIT_PUNCH, {
                    data: error,
                    responseCode: error.statusCode || 500
                });
                if (error.statusCode === 400 &&
                    error.message.includes('MealLockout')) {
                    logger_1.logger.emitCountMetric({
                        metricName: isHistorical
                            ? logger_1.METRICS.PUNCH_EDIT_MEAL_LOCKOUT_HISTORICAL.COUNT
                            : logger_1.METRICS.PUNCH_EDIT_MEAL_LOCKOUT_NON_HISTORICAL.COUNT,
                        dimensions
                    });
                }
                else {
                    logger_1.logger.emitCountMetric({
                        metricName: isHistorical
                            ? logger_1.METRICS.PUNCH_EDIT_REQUEST_HISTORICAL_ERROR.COUNT
                            : logger_1.METRICS.PUNCH_EDIT_REQUEST_NON_HISTORICAL_ERROR.COUNT,
                        dimensions
                    });
                }
            }
        });
    };
    return {
        editPunchState: {
            loading,
            data,
            error: error || null
        },
        editPunch
    };
}
exports.useEditPunch = useEditPunch;
